import script from "./TableMixin.vue?vue&type=script&lang=ts"
export * from "./TableMixin.vue?vue&type=script&lang=ts"

export default script